import React, { useCallback } from 'react';
import { List, Typography } from 'antd';
import dayjs from 'dayjs';
import { useQuery } from '@/shared/utils/utils';
import styles from './index.module.scss';
import { apiV2GgdDistributePagePost } from '@maxtropy/device-customer-apis-v2';
import { Modal, Paging, usePaging } from '@maxtropy/components';
import { isNil } from 'lodash-es';

const { Text } = Typography;

export interface ApplyLogModalProps {
  id?: number;
  visible: boolean;
  onCancel: () => void;
}

const ApplyLogModal: React.FC<ApplyLogModalProps> = ({ id, visible, onCancel }) => {
  const pagingInfo = usePaging(10);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;

  const { data, isLoading } = useQuery(
    useCallback(() => {
      if (isNil(id) || !visible) {
        return Promise.resolve([]);
      }
      return apiV2GgdDistributePagePost({
        id: id,
        page: pageOffset,
        size: pageSize,
      }).then(res => {
        if (res) {
          setTotalCount(res.total ?? 0);
        }
        return res.list ?? [];
      });
    }, [id, pageOffset, pageSize, setTotalCount])
  );

  return (
    <Modal
      destroyOnClose
      width={700}
      title="下发记录"
      bodyScroll={false}
      open={visible}
      footer={null}
      onCancel={onCancel}
    >
      <div className={styles.applyLog}>
        <List
          loading={isLoading}
          dataSource={data}
          renderItem={item => (
            <List.Item>
              <span>【{item.updateByUserName ?? '--'}】</span>
              在&nbsp;&nbsp;<span>{dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')}</span>&nbsp;&nbsp;下发了配置，
              下发状态：
              <Text type={item.distributeStatus === 0 ? 'warning' : item.distributeStatus === 1 ? 'success' : 'danger'}>
                {item.distributeStatus === 0 ? '下发中' : item.distributeStatus === 1 ? '成功' : '失败'}
              </Text>
            </List.Item>
          )}
        />
        <Paging pagingInfo={pagingInfo} />
      </div>
    </Modal>
  );
};

export default ApplyLogModal;
